import { render, staticRenderFns } from "./Your.vue?vue&type=template&id=096a0217&"
import script from "./Your.vue?vue&type=script&lang=js&"
export * from "./Your.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports